import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SpinLoading, Toast } from 'antd-mobile';
import { getMemberIdByQRCode } from '../services/api';

export default function MemberQRRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    
    if (!code) {
      // 如果没有 code 参数，直接跳转到注册页面
      navigate('/register', { replace: true });
      return;
    }

    // 通过 code 获取会员 ID
    const fetchMemberId = async () => {
      try {
        const memberId = await getMemberIdByQRCode(code);
        
        if (memberId) {
          // 跳转到注册页面，并传递会员 ID 作为邀请信息
          navigate(`/register?referId=${encodeURIComponent(memberId)}`, { replace: true });
        } else {
          // 如果获取失败，直接跳转到注册页面
          navigate('/register', { replace: true });
        }
      } catch (error) {
        console.error('Failed to get member ID:', error);
        Toast.show({
          icon: 'fail',
          content: error.message || 'Invalid member code',
        });
        // 跳转到注册页面
        navigate('/register', { replace: true });
      }
    };

    fetchMemberId();
  }, [searchParams, navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      gap: '16px',
    }}>
      <SpinLoading color="primary" style={{ fontSize: '48px' }} />
      <span style={{ color: '#666' }}>Loading...</span>
    </div>
  );
}
